import { Controller } from "@hotwired/stimulus"

// The confirming button submits a form that lives inside the dialog.
// Cancel, Escape, and a click on the backdrop close the dialog and
// never send that form, so a mis-click cannot publish or unpublish.
export default class extends Controller {
  static get targets() {
    return ["dialog"]
  }

  open(event) {
    event.preventDefault()
    this.showDialog()
  }

  cancel(event) {
    event.preventDefault()
    this.closeDialog()
  }

  cancelOnBackdrop(event) {
    if (event.target !== this.dialogTarget) return

    this.closeDialog()
  }

  showDialog() {
    const dialog = this.dialogTarget

    if (typeof dialog.showModal === "function") {
      if (!dialog.open) dialog.showModal()
      return
    }

    dialog.setAttribute("open", "")
  }

  closeDialog() {
    const dialog = this.dialogTarget

    if (typeof dialog.close === "function") {
      dialog.close()
      return
    }

    dialog.removeAttribute("open")
  }
}
